import { useTranslation } from 'react-i18next';
import { useIsProvisioningFiltered } from '../Filters/hooks/useIsProvisioningFiltered.ts';
import { NoRowsOverlay } from 'common/components/ConfigurableTable/Components/NoRowsOverlay.tsx';

export const BulkProvisioningNoRowsOverlay = () => {
  const { t } = useTranslation();
  const isFiltered = useIsProvisioningFiltered();

  return (
    <NoRowsOverlay
      message={isFiltered ? t('common.noResults') : t('bulkProvisioning.dragAndDrop')}
    />
  );
};
